import * as React from "react"
import styled from "styled-components";

const MaskPath = styled.path`
  stroke: none;
`

const PlanetMask = (props) => (
  <svg viewBox="0 0 4000 4000" {...props}>
    <MaskPath d="M0,0V4000H4000V0ZM2000,3125.11c-621.38,0-1125.11-503.73-1125.11-1125.11S1378.62,874.89,2000,874.89,3125.12,1378.62,3125.12,2000,2621.39,3125.11,2000,3125.11Z"/>
    <circle id="maskHole" cx="2000" cy="2000" r="1125.11"/>
  </svg>
)

export default PlanetMask
